import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import GoogleLogin from "./GoogleAuth";
import "./leftpanel.css";
import { config } from "../config";

const Leftpanel = () => {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("");
  const googleAuthRef = useRef(null);

  const location = useLocation();
  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const pathMap = {
      "/Dashboard": "Home",
      "/history": "History",
      "/privacy": "Privacy",
      "/refundpolicy": "Refund",
      "/terms&condition": "Terms",
    };
    setActiveButton(pathMap[location.pathname] || "");
  }, [location.pathname]);

  return (
    <div className="background_leftPanel">
      <div className="top_leftPanel">
        <div className="icon_title_leftpanel">
          <img src={config.logo} alt="Web logo" className="icon_leftpanel" />
          <div>AI Legal Generator</div>
        </div>

        <button
          onClick={() => handleNavigation("/premium")}
          className="buy_leftPanel"
        >
          <img src={config.crown} alt="proicon" />
          Buy Premium
        </button>

        <div className="buttons_leftPanel">
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "Home" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/")}
          >
            <img
              className="scroll-img"
              src={config.home_leftPanel}
              alt="home_icon"
            />{" "}
            Home
          </button>
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "History" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/history")}
          >
            <img
              className="scroll-img"
              src={config.history_leftPanel}
              alt="history_icon"
            />{" "}
            History
          </button>
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "Templates" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/templates")}
          >
            <img
              className="scroll-img"
              src={config.templateslp}
              alt="history_icon"
            />{" "}
            Templates
          </button>
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "Privacy" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/privacy")}
          >
            <img
              className="scroll-img"
              src={config.privacy_leftPanel}
              alt="privacy_icon"
            />{" "}
            Privacy Policy
          </button>
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "Refund" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/refundpolicy")}
          >
            <img
              className="scroll-img"
              src={config.refund_leftPanel}
              alt="refund_icon"
            />{" "}
            Refund Policy
          </button>
          <button
            className={`nav_buttons_leftpanle ${
              activeButton === "Terms" ? "active" : ""
            }`}
            onClick={() => handleNavigation("/terms&condition")}
          >
            <img
              className="scroll-img"
              src={config.terms_leftPanel}
              alt="terms_icon"
            />{" "}
            Terms & Conditions
          </button>
          {/* <button
                className={`nav_buttons_leftpanle ${activeButton === 'Blog' ? 'active' : ''}`}
                onClick={() => handleNavigation('/blog', 'Blog')}
            >
                <img className='scroll-img' src={config.blogs} alt="" /> Blog
            </button> */}
        </div>
      </div>
      <GoogleLogin
        ref={googleAuthRef}
        id="login_leftPanel"
        showDropdown={true}
      />
      {/* <GoogleButton id="logout_header" onLoginSuccess={handleLoginSuccess} onLoginFailure={handleLoginFailure} /> */}
    </div>
  );
};

export default Leftpanel;
